import { render } from "./mat-autocomplete.vue?vue&type=template&id=836cb332&lang=true"
import script from "./mat-autocomplete.vue?vue&type=script&lang=js"
export * from "./mat-autocomplete.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__